<template>
  <div>
    <h5>{{ $t('msg.User_agent') }}</h5>
    <el-tag type="info" translate="no"> {{ up_username }}</el-tag>
    <h5>{{ $t('msg.User_Name2') }}</h5>
    <div style="color: #67C23A"><b translate="no">{{ proxyUsername }}</b></div>
    <el-form :model="proxyInfo" :rules="userRules" ref="user">
      <el-form-item :label="$t('msg.Password2')" prop="password">
        <el-input v-model="proxyInfo.password" @focus="clearDefault" @blur="addDefaule" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('msg.Personal_secondary_password')" prop="password2">
        <el-input v-model="proxyInfo.password2" @focus="clearDefault2" @blur="addDefaule2" autocomplete="off"></el-input>
      </el-form-item>

      <el-button type="primary" @click="updateProxy">{{$t('msg.OK1')}}</el-button>
    </el-form>
  </div>
</template>

<script>
import {GetProxyInfo, adminUpdatePwd} from "../api";
var LxStr = function(str){
  if(str){
    var arr = str.split('');
    var flag = true;
    for (var i = 1; i < arr.length-1; i++) {
      var firstIndex = arr[i-1].charCodeAt();
      var secondIndex = arr[i].charCodeAt();
      var thirdIndex = arr[i+1].charCodeAt();
      // thirdIndex - secondIndex == 1;
      // secondIndex - firstIndex==1;
      if((thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex==1)){
        flag =  false;
      }
    }
    return flag;
  }
}
export default {
  name: "AdminUpdayePwd",
  data() {
    return {
      proxyUsername: '',
      up_username: '',
      proxyInfo: {realname: '', pnum: '', description: '', password: "******", password2: "******"},
      userRules: {
        password: [
          {required: true, message: this.$t('msg.Please_enter_your_password'), trigger: 'blur'},
          {min: 6, max: 15, message: this.$t('msg.The_length_is_616_characters'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === "******") {
                callback();
              }
              else if (value.search(/\d/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[a-zA-Z]/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[^a-zA-Z0-9\!\_-]/) != -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              }
              else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        password2: [
          { required: true, message: this.$t('msg.Please_enter_your_password'), trigger: 'blur' },
          { min: 6, max: 6, message: this.$t('msg.The_length_is_6_characters'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value==="******"){
                callback();
              }
              else if (isNaN(Number(value, 10))) {
                callback(new Error(this.$t('msg.Please_enter_a_numeric_value')));
              }else {
                callback();
              }
            },
            trigger: "blur"
          },
        ],
      },
    }
  },
  methods: {
    getProxyData() {
      GetProxyInfo({"search_username": this.proxyUsername}).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.proxyInfo.realname = data.data.params.data.realname
          this.proxyInfo.pnum = data.data.params.data.pnum
          this.proxyInfo.description = data.data.params.data.description
          this.up_username = data.data.params.data.up_username
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Failed_to_obtain_data')
          }
          this.$message({
            message: msg,
            type: 'error',
            offset: 80
          });
        }
      })
    },
    updateProxy() {
      var val = true
      var from = 'user'
      this.$refs[from].validate(valid => {
        if (!valid) {
          // 表单验证失败，显示错误消息...
          val = false
        }
      })
      //添加代理
      if (val) {
        var params = {}
        if (this.proxyInfo.password !== "******" && this.proxyInfo.password2 !== "******") {
          return
        }
        if (this.proxyInfo.password !== "******"){
          params["password"] = this.proxyInfo.password
        }
        if (this.proxyInfo.password2 !== "******"){
          params["password2"] = this.proxyInfo.password2
        }
        params["proxy_username"] = this.proxyUsername
        adminUpdatePwd(params).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.proxyInfo.password = "******"
            this.proxyInfo.password2 = "******"
            this.$alert(this.$t('msg.Modification_successful'), '', {
              confirmButtonText: this.$t('msg.OK2'),
              center: true,
              type: 'success',
              showClose: false,
              customClass:'alert'//添加类名
            })

          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Failed_to_obtain_data')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }
    },
    clearDefault(){
      if(this.proxyInfo.password === "******"){
        this.proxyInfo.password = ""
      }
    },
    addDefaule(){
      if(this.proxyInfo.password === ""){
        this.proxyInfo.password = "******"
      }
    },
    clearDefault2(){
      if(this.proxyInfo.password2 === "******"){
        this.proxyInfo.password2 = ""
      }
    },
    addDefaule2(){
      if(this.proxyInfo.password2 === ""){
        this.proxyInfo.password2 = "******"
      }
    }
  },
  mounted() {
    this.proxyUsername = this.$route.query.proxyName
    this.getProxyData()
  }
}
</script>

<style lang="less">
/* 使用媒体查询来调整样式 */
@media screen and (max-width: 500px) {
  .alert{
    width: 240px;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/AdminUpdatePwd.vue